$(document).ready(function() {
	$('body').addClass('vi-images-on');

	$(document).on('click', '.js-vi-images-on', function() {
		$('body').addClass('vi-images-on');
		$('body').removeClass('vi-images-off');
	});

	$(document).on('click', '.js-vi-images-off', function() {
		$('body').removeClass('vi-images-on');
		$('body').addClass('vi-images-off');
	});
});


// WEBPACK FOOTER //
// ./src/js/visually-impaired/image.js